import { Card } from '@/components_deprecated/Card'
import styled, { css } from 'styled-components'

interface ShortcutsWrapperProps {
  $alignWithSpaceBetween?: boolean
}

export const ShortcutsWrapper = styled(Card).attrs<ShortcutsWrapperProps>(
  (props: ShortcutsWrapperProps) => ({
    $alignWithSpaceBetween: props.$alignWithSpaceBetween ? true : false,
  })
)`
  display: inline-flex;
  ${props =>
    props.$alignWithSpaceBetween
      ? css`
          justify-content: space-between;
        `
      : css`
          flex-wrap: wrap;
          column-gap: 2rem;
          row-gap: 2rem;
        `}

  align-items: center;
  width: 100%;
  padding: 2.5em 2.5em 1.8em;

  background: white;

  ${props => props.theme.layout.mobile} {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;

    max-width: 100%;
    padding: 12px;
  }
`
